import { render, staticRenderFns } from "./price-format.vue?vue&type=template&id=607e8bc7&"
import script from "./price-format.vue?vue&type=script&lang=ts&"
export * from "./price-format.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports